module.exports = __webpack_public_path__ + "img/header_bg.561e8e3.png";